// src/utils/editor/replaceDuplicateJokes.js

/**
 * Replaces duplicate jokes in the organized bits with objects from previous bits if they match.
 *
 * Inputs:
 * - organizedBitsArray: The array of strings that comes from rawText.
 * - previousBitsArray: The array of bits that may contain objects with setup/punchline/tagline info.
 *
 * Output:
 * - Returns a new array where matching strings are replaced by their object equivalents from previousBitsArray.
 */
export const replaceDuplicateJokes = (organizedBitsArray, previousBitsArray) => {
  return organizedBitsArray.map((bit, bitIndex) => {
    return bit.map((joke, jokeIndex) => {
      // Look for a matching string in previousBitsArray
      const previousJoke = previousBitsArray[bitIndex] && previousBitsArray[bitIndex][jokeIndex];
  
      // If previousJoke is an object, unpack its setup, punchline, and taglines
      if (previousJoke && typeof previousJoke === 'object') {
        const originalText = [...previousJoke.setup, previousJoke.punchline.text, ...previousJoke.taglines.map(tagline => tagline.punchline.text)].join('\n');
  
        // Only replace if the original text matches exactly with the current joke string
        if (originalText === joke) {
          return previousJoke;  // Replace string with the object
        }
      }
  
      // If no exact match is found, return the string
      return joke;
    });
  });
};
   